/** @jsxImportSource @emotion/react */

import { css } from '@emotion/react';
// import seminargoLogo from 'https://www.seminargo.at/wp-content/uploads/2023/01/seminargo_logo-768x155-1.png'
// import menuIcon from 'https://www.seminargo.at/wp-content/uploads/2023/01/hamburger-menu-icon.svg'
import { useState, useEffect } from 'react';
import getToken from './getToken.js';

import DynamicIcon from './DynamicIcon';
import Carousel from './Carousel3X2.js';
import TextSlideshow from './TextSlideshow';
import VideoPlayer from './VideoPlayer';
import VideoSlideshow from './VideoSlideshow';
import Autocomplete from './Autocomplete';
import BoosterCarousel from './BoosterCarousel';

const seminargoLogo = 'https://www.seminargo.at/wp-content/uploads/2023/03/seminargo-logo-white.svg'
// const seminargoLogo = 'https://www.seminargo.at/wp-content/uploads/2023/01/seminargo_logo-768x155-1.png'
// const menuIcon = 'https://www.seminargo.at/wp-content/uploads/2023/01/hamburger-menu-icon.svg'

const seminargoViolet = '#AC2A6E'
const lightGray = '#F4F4F4';
const darkGray = '#5E646B';
const seminargoBlue = '#1A2B38'
const lightBlue = '#5CACF3'

// const backgroundPhoto = 'https://www.seminargo.at/wp-content/uploads/2021/04/cropped-Kothmuehle-Seminar21661_7172-Bohn-und-Holzapfel-Kombi.jpg'
const backgroundPhoto = 'https://www.seminargo.at/wp-content/uploads/2022/11/cropped-Kothmuehle-Seminar21661_7172-Bohn-und-Holzapfel-Kombi-2.webp'

const appStyles = css`
  font-family: 
 Montserrat, Futura, system-ui, -apple-system, BlinkMacSystemFont, Segoe UI,
    Roboto, Helvetica Neue, Arial, Noto Sans, sans-serif, Apple Color Emoji,
    Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;
  background: #FFFFFF;
  width: 100%;
  max-width: 1920px;
  display: flex;
  flex-direction: column;
  align-items: center;

  .clustersContainer {
    margin-top: -10rem;


  @media (max-width: 1800px) {
  margin-top: -3rem;
}

    @media (max-width: 1500px) {
  margin-top: 0;
}
    
@media (max-width: 1200px) {
  margin-top: 3rem;
}

@media (max-width: 990px) {
  margin-top: 6rem;
}

@media (max-width: 850px) {
  margin-top: 7rem;
}

@media (max-width: 700px) {
  margin-top: 10rem;
}

@media (max-width: 600px) {
  margin-top: 12rem;
}

@media (max-width: 550px) {
  margin-top: 15rem;
}

@media (max-width: 500px) {
  margin-top: 18rem;
}

@media (max-width: 370px) {
  margin-top: 20rem;
}

@media (max-width: 350px) {
  margin-top: 25rem;
}

@media (max-width: 300px) {
  margin-top: 28rem;
}

@media (max-width: 250px) {
  margin-top: 35rem;
}


span {
  backdrop-filter: none!important;
}
  }

  
  button {

    border: 1px solid rgba(96, 96, 96, 0.7);
    border-radius: 10px;
    font-size: 0.8rem;
    font-weight: 600;
    line-height: 1.5rem;
    transition: all 0.35s ease-in-out;
  }
  button:hover {
    color: white;
    cursor: pointer;
  }
  h1 {
    width:70%;
    margin: 15vw  0 0 0;
    font-size: 2.5rem;
    font-weight: 700;
    color: #FFFFFF;


    @media (max-width: 850px) {
      ${'' /* margin: 10vw  0 0 0; */}
      font-size: 2rem;
    }

    @media (max-width: 700px) {
      margin: 6vw  0 0 0;
    }

    @media (max-width: 660px) {
      text-align: center;
      width: 100%;
    }



  }
  h2 {
  }
  h4 {
  }

  p {
    font-size: 0.8rem;
  }

  a {
    text-decoration: none;
  }

  hr {
    ${'' /* border: 1px solid ${darkGray}; */}
    height: 0.5px; /* This sets the height of the horizontal line to 0.5 pixels */
  border: none; /* This removes the border around the horizontal line */
  background-color: ${seminargoViolet};; /* This sets the color of the horizontal line */
    width: 70%;
    margin-top: 0px;
    align-items: center;

    @media (max-width: 1100px) {
      width: 97%;
   }
  }
`;

const headerStyles = css`
height: 45vw;
max-height: 870 px;
width: 100%;
display: flex;
flex-direction: column;
align-items: center;
background-image: url(${backgroundPhoto}});
aria-label: "Seminarraum in der Kothmühle";
background-size: cover;
background-position: center;

@media (max-width: 1900px) {
  height: 50vw;
}

@media (max-width: 1500px) {
  height: 50rem;
}
@media (max-width: 1180px) {
  height: 40rem;
}

@media (max-width: 900px) {
  height: 35rem;
}

${'' /* @media (max-width: 800px) {
  height: 30rem;
} */}


${'' /* @media (max-width: 300px) {
  height: 32rem;
} */}



`;

const navStyles = css`
width: 100%;
padding: 1vw 0 2vw 0;
  ${'' /* height: 5vh; */}
  min-height: 20px;
  max-height: 250px;
  ${'' /* position: sticky; top: 0vh; */}
  z-index: 1;
  background-color: rgba(255, 255, 255, 0.4);


  a {
    font-size: 0.8rem;
  }



  .whole-div {
    width: 70%;
    display: flex;
    flex-direction: row;
    ${'' /* padding: 10px 0px; */}
    margin: auto;

  }

  .whole-div-mobile {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;

  }

  .menuWrapper {
    display: flex;
    flex-direction: column;
    align-items: right;
  }

  .menuNoshow {
    display: none;
  }

  .menuShow {
    display: flex;
    flex-direction: column;
    justify-content: center;
   a {
    decoration: none;
  }
  ul {
    list-style-type: none;
    padding: 0;
    align-items: right;
  }

  li {

  }

  }
  

 .logo {
  justify-content: flex-start;
  padding-left: 1rem;
  
  img {
    height: 80%;
    max-height: 40px;

    @media (max-width: 300px) {
     width: 100%;
    }
  }
 }

 .navLinks {
    display: flex;
    justify-content:center;
    align-items: center;
    width: 100%;
    max-width: 1000px;
    gap: 10px;
    font-size: 1rem;
    line-height: 1.5rem;
    font-weight: 600;
    font-color: #FFFFFF;
  }

 .social {
  justify-content: flex-end;
  gap: 10px;
 }


  div {
    display: flex;
    justify-content: space-around;
    align-items: center;
  }

  a {
    text-decoration: none;
    color: ${seminargoViolet};
    font-size: 1rem ;
  }
  a:hover {

  }

  img {
    max-width: 250px;
    max-height: 50px;
  }


 
   /* Dropdown Button */
   .dropbtn {
    background-color: transparent;
    color: ${seminargoViolet};
    padding: 0 16px;
    font-size: 22px;
    font-weight: bold;
    border: none;
    ${'' /* font-family: Futura, system-ui, -apple-system, BlinkMacSystemFont, Segoe UI,
      Roboto, Helvetica Neue, Arial, Noto Sans, sans-serif, Apple Color Emoji,
      Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji; */}

      ${'' /* img { */}
        ${'' /* max-width: 30px; */}
         /* filter changes normally black color into the Seminargo violet*/
        ${'' /* filter: invert(20%) sepia(36%) saturate(5752%) hue-rotate(310deg) brightness(89%) contrast(82%);
      } */}
  }
  /* Dropdown Content (Hidden by Default) */
  .menuShow {
    ${'' /* display: none; */}
    position: absolute;
    top: 8vh;
    right:0;
    background-color: ${lightGray};
    min-width: 200px;
    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
    z-index: 1;
    font-size: 20px;
    ${'' /* font-family: Futura, system-ui, -apple-system, BlinkMacSystemFont, Segoe UI,
      Roboto, Helvetica Neue, Arial, Noto Sans, sans-serif, Apple Color Emoji,
      Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji; */}
  }
  /* Links inside the dropdown */
  .menuShow a {
    color: ${seminargoViolet};
    padding: 12px 16px;
    text-decoration: none;
    display: block;
  }
  /* Change color of dropdown links on hover */
  .menuShow a:hover {
    color: ${seminargoBlue};
  }
  /* Show the dropdown menu on hover */
  .dropdown:hover .menuShow {
    display: block;
    width: 200px;
    margin-top: 28vh;
  }
  /* Change the background color of the dropdown button when the dropdown content is shown */
  .dropdown:hover .dropbtn {
    color: ${seminargoViolet};
  }
  `

  const searchStyles = css`

display: flex;
flex-direction: column;
justify-content: flex-start;
margin: 1vw;
padding: 1.1vw;
gap: 0.9vw;
width: 67%;
background: rgba(20, 22, 45, 0.4);
border: 6px solid rgba(255, 255, 255, 0.11);
box-shadow: 53.695px 50.3901px 214.78px rgba(16, 18, 56, 0.4);
backdrop-filter: blur(12.5px);
/* Note: backdrop-filter has minimal browser support */
border-radius: 25px;

.searchText {

  @media (max-width: 700px) {
    display: flex;
    flex-direction: column;
    align-items: center;
}

}



button {
    color: white;
    background-color: ${seminargoViolet};
    border: 1px solid rgba(96, 96, 96, 0.7);
    border-radius: 10px;
    padding: 0.3rem 1rem;
    font-size: 0.8rem;
    font-weight: 500;
    line-height: 1.5rem;
    transition: all 0.35s ease-in-out;

    @media (max-width: 700px) {
      width: 10rem;
      color: white;
      background-color: ${seminargoViolet};
    
    }
  }
  button:hover {
    background-color: ${seminargoBlue};
    color: white;
    cursor: pointer;

    @media (max-width: 700px) {
      background-color: white;
      color: ${seminargoViolet};
    }
  }

div > h3 {
  font-size: 1.5rem;
  font-weight: 700;
  color: white;
  margin: 0;

  @media (max-width: 750px) {
      font-size: 1.2rem;
    }
  @media (max-width: 600px) {
      font-size: 1rem;
  }
}

div > p {
  font-size: 0.8rem;
  font-weight: 400;
  color: white;
  margin: 0;
}

.inputFields {
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    @media (max-width: 700px) {
      flex-direction: column;
      align-items: center;
    }

  }

  #singleInput {
  flex: 3 1 auto;
  width: 100%;

  @media (max-width: 700px) {
    margin-bottom: 0.5rem;
  }

  label {
  display: block;
  width: 90%;
  margin-bottom: 0.5rem;
  font-size: 0.8rem;
  font-weight: 400;
  color: white;
  margin: 0;
  padding-bottom: 0.2rem;
}

  input {
    width: 90%;
    padding-left: 0.8rem;
    border: 1px solid rgba(96, 96, 96, 0.7);
    border-radius: 10px;
    line-height: 1.9rem;
  }
  }

 #searchButton {
    display: flex;
    flex: 1 1 auto;
    flex-direction: column;
    justify-content: flex-end;
    align-items: flex-end;
  }

  `

  const emptySpace = css`
    position: relative;
  width: 100%;
  height: 45vw;
  `;




  const boosterHotelsStyles = css`
  display: flex;
  flex-direction: column;
  width: 70%;
  ${'' /* height: 100%; */}
  margin-top: -5vw;
  padding: 2rem 0;
  position: absolute;
  ${'' /* top: 10vw; */}
left: 15%;
background: #FFFFFF;
box-shadow: 0px 81px 102px rgba(0, 0, 0, 0.04);
border-radius: 35px;




  .clusterTitle {
    display: flex;
    flex-direction: column;
    justify-content: center;

    h2 {
font-size: 1.5rem;
font-weight: 700;
color: ${seminargoViolet};
text-align: center; /* center the text horizontally */
margin-block-start: 0;
margin-block-end: 0;

}

p {
font-size:1rem;
font-weight: 400;
text-align: center; /* center the text horizontally */
margin-block-start: 0;
margin-block-end: 0;
margin: 0.5rem 0 1rem 0;
}
  }

.clusters {
  display: flex;
  justify-content: center;
  width: 100%;

}


.row, .textRow {
  display: flex;
  flex-direction: row;

}

.textRow {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  }

  .item-wrapper {
    flex-grow: 1;
  }


.item {
  ${'' /* flex-grow: 1; */}
  min-width: 150px;
  height: 33vw;
  width: calc(30vw * 0.66);
  max-height: 500px;
  min-height: 225px;
  background-color: ${seminargoViolet};
  border-radius: 20px; 
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  font-size: 1rem;
  text-align: center;
  color: white;
  decoration: none;
  margin: 10px; 

  @media (max-width: 600px) {
    height: 40vw;
  }

  @media (max-width: 500px) {
    height: 50vw;
  }


  div {
    display: flex;
    flex-grow: 1;

  }

  a {
    text-decoration: none;
    color: ${seminargoViolet};
  }

  #icon {
    height: 2rem;
  } 


  span {
    height: 20%;
    width: 100%;
    font-size: 0.9rem;
    margin-bottom: 1rem;
    backdrop-filter: blur(20px);
    display: flex; 
  justify-content: center; 
  align-items: center; 



  }
}

.controls {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 1rem;

  button {
    background-color: ${seminargoViolet};
    color: white;
    border: none;
    border-radius: 10px;
    margin: 0 5px;
    height: 3rem;
    width: 3rem;
    align-items: center;
    justify-content: center;
    font-size:1.7rem;   ${'' /* defines the size of the arrows */}


  }

  button:hover {
    background-color: ${seminargoBlue};
  }

  button:disabled {
    background-color: ${darkGray};
    cursor: default;
  }
}

  `;

  const clusterStyles = css`
  display: flex;
  flex-direction: column;
  width: 70%;
  


#newTexts {
  margin-top: 2rem;
}

  .clusterTitle {
    display: flex;
    flex-direction: column;
    justify-content: center;

    h2 {
font-size: 1.5rem;
font-weight: 700;
color: ${seminargoViolet};
text-align: center; /* center the text horizontally */
margin-block-start: 0;
margin-block-end: 0;
margin-top: 1rem;
margin-bottom: 1rem;

}

p {
font-size:1rem;
font-weight: 400;
text-align: justify; /* center the text evenly */
margin-block-start: 0;
margin-block-end: 0;
margin-bottom: 1rem;
}
  }

.clusters {
  display: flex;
  justify-content: center;
  width: 100%;

}

.carousel {
${'' /* display: flex;
flex-direction: column;; */}
${'' /* flex-wrap: wrap; */}
}

.row, .textRow {
  display: flex;
  flex-direction: row;

}

.textRow {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  }

  .item-wrapper {
    flex-grow: 1;
  }


.item {
  ${'' /* flex-grow: 1; */}
  min-width: 150px;
  height: 33vw;
  width: calc(30vw * 0.66);
  max-height: 500px;
  min-height: 225px;
  background-color: ${seminargoViolet};
  border-radius: 20px; 
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  font-size: 1rem;
  color: white;
  decoration: none;
  margin: 10px; 

  @media (max-width: 600px) {
    height: 40vw;
  }

  @media (max-width: 500px) {
    height: 50vw;
  }

  div {
    display: flex;
    flex-grow: 1;

  }

  a {
    text-decoration: none;
    color: ${seminargoViolet};
  }

  #icon {
    height: 2rem;
  } 


  span {
    height: 20%;
    text-align: justify;
    font-size: 0.9rem;
    line-height: 1rem;
    padding: 0.5rem;
    backdrop-filter: blur(20px);
    border-radius: 0 0 20px 20px;
  overflow: hidden;
  ${'' /* text-overflow: ellipsis; */}
  max-width: 100%; /* optional, adjust as needed */

  }
}

.controls {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 1rem;

  button {
    background-color: ${seminargoViolet};
    color: white;
    border: none;
    border-radius: 10px;
    margin: 0 5px;
    height: 3rem;
    width: 3rem;
    align-items: center;
    justify-content: center;
    font-size:1.7rem;   ${'' /* defines the size of the arrows */}


  }

  button:hover {
    background-color: ${seminargoBlue};
  }

  button:disabled {
    background-color: ${darkGray};
    cursor: default;
  }
}

  `;

  

  const boosterAdStyles = css`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 70%;
  background: white;
  box-shadow: 0px 62px 123px rgba(0, 0, 0, 0.05);
  border-radius: 47px;
  margin-top: 3rem;
  padding: 10px;

  @media (max-width: 900px) {
    flex-direction: column;
  }

  .videoBoosterStyles {
  width: 50%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  border-radius: 50%;
  overflow: hidden;
  padding: 20px;

  @media (max-width: 900px) {
    width: 100%;

    .vector1, .vector2 {
      ${'' /* padding: 10px */}
    }
  }

}



.boosterVideoIframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%; /* fills the height of the container */
  }

#videoBooster {
  position: relative;
  width: 100%;
  padding-top: 100%; /* creates a square shape */
  overflow: hidden; /* hides the overflow of the width */
  }


  .vector1, .vector2 {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 25px;
  border-radius: 50%;
  transform: rotate(45deg); /* Rotate by 45 degrees */
}

.vector1::before, .vector2::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  border-top: 2px solid ${seminargoBlue} ;
  border-right: 2px solid transparent;
  pointer-events: none; /* Make the pseudo-element transparent to pointer events */

}

.vector1::after, .vector2::after {
  content: "";
  position: absolute;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  border-bottom: 2px solid ${seminargoViolet} ;
  border-left: 2px solid transparent;
  pointer-events: none; /* Make the pseudo-element transparent to pointer events */

}


.vector2 {
  transform: rotate(90deg);

  div {
  }
}

.videoContainer {
  position: relative;
  width: 100%;
  height: 100%;

}

.boosterText {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  ${'' /* align-items: start; */}
  width: 50%;
  margin: 30px;

  @media (max-width: 900px) {
    width: 90%;

    p {
      text-align: justify;
      padding-top: 1rem;
    }


  }

  h2 {
  font-size: 1.5rem;
  font-weight: 700;
  color: ${seminargoViolet};
  margin-block-start: 0;
  margin-block-end: 0;
}

h5 {
  font-size:1rem;
  font-weight: 400;
  margin-block-start: 0;
  margin-block-end: 0;
  color: ${lightBlue};
}

p {
  font-size:1rem;
  font-weight: 400;
  margin-block-start: 0;
  margin-block-end: 0;
  margin-bottom: 1rem;

}

li {
  font-size:1rem;
  font-weight: 400;

}

button {
  background-color: ${seminargoBlue};
  color: white;
  border: none;
  border-radius: 5px;
  line-height: 2rem;
  height: 3rem;
  width: 10rem;

  @media (max-width: 900px) {
    width: 100%;
    margin-top: 1rem;
    text-align: center;
  }

}
button:hover {
    background-color: ${seminargoViolet};
  }
  }
  `;



  const emptySpace2 = css`
  
  width: 100%;
  height: 20rem;
  background: ${darkGray};
  margin-top: 3rem;

  @media (max-width: 400px) {
    height: 30rem;
  }
  `;





const videoStyles = css`
width: 70%;
display: flex;
flex-direction: row;
flex-wrap: wrap;
justify-content: center;
align-items: center;
margin-top: -17.5rem;

@media (max-width: 600px) {
  width: 100%;
}

@media (max-width: 400px) {
  margin-top: -28rem;
}

.videoTitle {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  width: 70%;

  h2, p {
    text-align: center;
    color: white;
    margin-block-start: 0;
    margin-block-end: 0;
  }

  h2 {
    font-size: 1.5rem;
    font-weight: 700;
  }

  p {
    font-size: 1rem;
    font-weight: 400;
  }
}


.video-carousel-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-top: 2rem;
}

.video-carousel-current {
  position: relative;
  justify-content: center;
  border: 7px solid white;
  border-radius: 10px;

  @media (max-width: 850px) {
    ${'' /* width: 800px; */}
    width: 90%;
    iframe {
      width: 100%;
    }
  }
}

.video-carousel-thumbnails {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 20px 0;
}

.video-carousel-thumbnail {
  margin: 0 10px;
  cursor: pointer;
}

.video-carousel-thumbnail.active {
  border: 2px solid ${seminargoViolet};
}

.video-carousel-thumbnail img {
  width: 100%;
  height: auto;
}

.video-carousel-controls {
  display: flex;
  justify-content: center;

}

.video-carousel-controls button {
  background-color: ${seminargoViolet};
    color: white;
    border: none;
    border-radius: 10px;
    margin: 0 5px;
    height: 3rem;
    width: 3rem;
    align-items: center;
    justify-content: center;
     font-size:1.7rem;  

}

.video-carousel-controls button:hover {
  background-color: ${seminargoBlue};
}


`;

const footerStyles = css`
margin-top: 4rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  h2 {
    color: ${seminargoBlue};
    font-size: 3rem;
    font-weight: 700;
    margin-block-start: 0;
    margin-block-end: 0;

  }

  h4 {
    color: ${seminargoBlue};
    font-size: 1rem;
    font-weight: 700;
    margin-block-start: 0;
    margin-block-end: 0;
  }

  h5 {
  font-size:1rem;
  font-weight: 400;
  margin-block-start: 0;
  margin-block-end: 0;
  color: ${lightBlue};
}

  p {
    color: ${seminargoBlue};
    font-size: 0.8rem;
    font-weight: 400;
    margin-block-start: 0;
    margin-block-end: 0;

  }

  .footerTitleAndMap {
    width: 70%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    @media (max-width: 768px) {
      width: 90%;
    }
  }

  .footerTitle {
    display: flex;
    flex-direction: column;
    width:40%;

    h2 {
      word-wrap: normal;
    }

    #secondh2 {
      color: ${seminargoViolet};
    }

    #footTitleText {
      color: ${seminargoBlue};
      margin-top: 1rem;
    }

    button {
      background-color: ${seminargoBlue};
      color: white;
      border: none;
      border-radius: 10px;
      height: 2rem;
      width: 8rem;
      align-items: center;
      justify-content: center;
      font-size:1rem;
      margin-top: 2rem;
    }

    button:hover {
      background-color: ${seminargoViolet};
      cursor: pointer;
    }

    iframe {
  border: none;
}

.modal {
    width: 800px;
    height: 400px;
    z-index: 100;

    @media (max-width: 950px) {
      width: 600px
    }
    @media (max-width: 750px) {
      width: 250%
    }

  }

  .modal-header {
    display: flex;
    flex-direction: row;
    justify-content: end;
  }

  .close-btn {
    width: 2rem;
  }

  }

  .footerMap {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 60%;
    height: 20vw;

    iframe {
        filter: grayscale(100%);
        opacity: 0.4;
        border-radius: 15px;
        margin-bottom: 0;

        @media (max-width: 1200px) {
          margin-top: 2rem;
    }

        @media (max-width: 950px) {
          margin-top: 17rem;
    }
    @media (max-width: 500px) {
          margin-top: 20rem;
    }
    }

  }



  .contactData {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    ${'' /* align-items: left; */}
    width: 70%;
    margin-top: 4rem;

    @media (max-width: 950px) {
      width: 80%;
    }

        @media (max-width: 800px) {
      width: 100%;
    }
    @media (max-width: 650px) {
      flex-direction: column;
      margin-top: 1rem;
      background: ${seminargoViolet};
      border-radius: 15px 15px 0 0;
      padding-top: 1rem;
      align-items: center;

    }
  }



  .location, .phone, .email {
    display: flex;
    flex-direction: row;
    width: 33%;
    height: 5vw;
    min-height: 60px;
    margin: 0 10px -3vw 10px;
    ${'' /* padding-bottom: 1rem; */}
    background: white;
    border-radius: 10px;
    z-index: 1;

    @media (max-width: 1300px) {
      ${'' /* padding-bottom: 2rem; */}
    }

    @media (max-width: 1100px) {
      ${'' /* padding-bottom: 1rem; */}
    }

    @media (max-width: 900px) {
      ${'' /* padding-bottom: 2rem; */}
    }

    @media (max-width: 650px) {
    height: 10vw;
    width: 70%;
    margin: 0 10px;
    border-radius: 0;
    padding-top: 0;
    padding-bottom: 0;

    }

    @media (max-width: 450px) {
      width: 90%;
    }

    svg{
      margin: 0 1rem;
      padding-bottom: 5px;
      color: ${seminargoBlue};

      @media (max-width: 650px) {
        height: 70%;
      }
    }
  }

  .iconStyle {
    font-size: 3rem;
    width: 35%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;


  }

  .locationData, .phoneData, .emailData  {
    display: flex;
    flex-direction: column;

  }

  .rectangle {
  width: 100%;
  height: 8rem;
  background: ${seminargoViolet};
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: end;

  @media (max-width: 1000px) {
    height: 6rem;
  }

  @media (max-width: 650px) {
    height: 4rem;
  }

  @media (max-width: 530px) {
    flex-direction: column;
    height: 5rem;
    justify-content: center;
    align-items: center;
  }
  
  a {
    color: white;
    text-decoration: none;
    margin: 5px;
  }

  svg {
    height: 1.5rem;
    padding-right: 10px;
  }




  }

  .socialFooter {
    margin-left: 15%;
    margin-bottom: 1rem;
    @media (max-width: 950px) {
      margin-left: 10%;
    }
    @media (max-width: 800px) {
      margin-left: 5%;
    }

    @media (max-width: 530px) {
      margin-bottom: 0;
      margin-left: 0;
      margin-top: 1rem;
    }


  }

  .linksFooter {
    margin-right: 15%;
    margin-bottom: 1rem;

    @media (max-width: 950px) {
      margin-right: 10%;
    }

    @media (max-width: 800px) {
      margin-right: 5%;
    }

    @media (max-width: 530px) {
      margin-bottom: 0;
      margin-left: 0;
    }

    @media (max-width: 280px) {
      margin-right: 0%;
      ${'' /* font-size: 0.8rem; */}
    }
  }
  `;



function App() {

  // find out what is the width of the window
  const [windowWidth, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    // console.log('width: ' + width)
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [windowWidth]);

  // show menu on mobile

  const [showMenu, setShowMenu] = useState(false);


const [isLoading, setIsLoading] = useState(false);
const [error, setError] = useState(null);

function sanitizeData(name) {
  return name.replace(/[^a-zA-Z0-9 öäüßÖÄÜ]/g, '');
}

  async function updateEventTypesFile(place, type) {
    
    const mediaId = 389865;
    const fileUrl = `https://www.seminargo.at/wp-json/wp/v2/event-list/${mediaId}`;
    const sanitizedPlace = sanitizeData(place)
    const sanitizedType = sanitizeData(type)
    
    try {
      const response = await fetch(fileUrl, {
  headers: {
    'Cache-Control': 'no-cache'
  }
});
      
      const dataObject = await response.json();
      const data = dataObject.content.rendered;

          // process the data
    const updatedData = processData(data, sanitizedPlace, sanitizedType);
    // console.log('Changed data: ' + updatedData )

    //get the token
    const token = await getToken();
    // post the updated data back to the server
    const updatedResponse = await fetch(fileUrl, {
      method: 'PUT',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'

      },
      body: JSON.stringify({
        content: `${updatedData}`
      })
    });


    // console.log(await updatedResponse.json())
    
    if (updatedResponse.ok) {
     // console.log('File updated successfully!');
    } else {
      // console.log('Failed to update file!');
    }
  } catch (error) {
    console.log(error);
  }
}

function processData(data, placeFromInput, typeFromInput) {

const current = new Date();
const date = `${current.getDate()}/${current.getMonth()+1}/${current.getFullYear()}/${current.getHours()}:${current.getMinutes()}:${current.getSeconds()}`;
const newEvent = `<li>${date} - ${placeFromInput} - ${typeFromInput}</li>`;


const ulEndIndex = data.lastIndexOf('</ul>');

if (ulEndIndex !== -1) {
    // insert new event before the </ul> tag
    data = data.slice(0, ulEndIndex) + newEvent + data.slice(ulEndIndex);
  } else {
    // </ul> not found, so just append the new event to the end
    data += `\n${newEvent}`;
  }

  return data;


}


function goToSearchPage(place) {
  // console.log(place)
 if ( place == null || place === '' ) { window.open(`https://www.seminargo.com`, '_blank')}
 else {
  const changedPlace = place.replace('ä', 'ae').replace('ö', 'oe').replace('ü', 'ue').replace('ß', 'ss').toLowerCase();
  // window.open(`https://www.seminargo.com/hotels/${changedPlace}`, '_blank');
  // const confirmation = window.confirm('You are being transferred to another site. Do you want to continue?');
  // if (confirmation) {
    // window.alert('You are being transferred to Seminargo search engine. Please wait...')
    window.open(`https://www.seminargo.com/hotels/${changedPlace}`, '_blank');
  // }
 }
}



const [suggestions, setSuggestions] = useState([])
useEffect(() => {
async function getSuggestions() {
  const suggestions =await Autocomplete()
  // console.log(suggestions)
  // console.log(suggestions.length)
  setSuggestions(suggestions)
  return suggestions
}
getSuggestions()

}, [])  


  
  const [place, setPlace] = useState('');
  const [placeId, setPlaceId] = useState(0);
  const [eventType, setEventType] = useState('');

  useEffect(() => {
    const suggestion = suggestions.find(suggestion => suggestion.name === place);
    setPlaceId(suggestion ? suggestion.id : 25119);
    // console.log(placeId);
    // console.log(place)
  }, [place, suggestions, placeId]);

  const handleSearch = () => {
    updateEventTypesFile(place, eventType);
    goToSearchPage(place)
  };


  const [showModal, setShowModal] = useState(false);

  const handleContactClick = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };


  return (
    
<div css={appStyles}>
{error && <div>{error}</div>}
{isLoading && <div>Loading...</div>}
<div css={headerStyles} className="siteHeader">
  <div css = {navStyles}>
 {windowWidth > 1100 ? (
  <div className="whole-div">
      
      <div className="logo">
        <a href="https://www.seminargo.at"><img src={seminargoLogo} alt="seminargo logo" /></a>
      </div>
      <div className="navLinks">
        <a href="#boosterHotels">Empfehlung</a>
        <a href="#clusters">Themen</a>
        <a href="#salesBooster">Booster</a>
        <a href="#newTexts">Neuigkeiten</a>
        <a href="#videos">Videos</a>
        <a href="#footer">Kontakt</a>
        <a href="https://www.seminargo.com/faq">FAQ</a>
      </div>
      <div className="social">
      <a aria-label="Facebook" href="https://www.facebook.com/profile.php?id=100089909419195"><DynamicIcon icon={"facebook"} /></a>
      <a aria-label="Instagram" href="https://www.instagram.com/seminargocom/"><DynamicIcon icon={"instagram"} /></a>
      <a aria-label="LinkedIn" href="https://www.linkedin.com/company/seminargo-gmbh"><DynamicIcon icon={"linkedin"} /></a>
      </div>
    </div>
 ) : (
  <div className="whole-div-mobile">
  <div className="logo">
        <a href="https://www.seminargo.at"><img src={seminargoLogo} alt="seminargo logo" /></a>
  </div>
  <div className="menuWrapper">
      <button aria-label="mobile-menu-button" className="dropbtn" id="dropbtn" onClick={() => setShowMenu(!showMenu)}>☰</button>
      <div className={`menu${showMenu ? 'Show' : 'Noshow'}`} id={`menu${showMenu ? 'Show' : 'Noshow'}`}>
  <ul>
        <li><a href="#boosterHotels">Empfehlung</a></li>
        <li><a href="#clusters">Themen</a></li>
        <li><a href="#salesBooster">Booster</a></li>
        <li><a href="#newTexts">Neuigkeiten</a></li>
        <li><a href="#videos">Videos</a></li>
        <li><a href="#footer">Kontakt</a></li>
        <li><a href="https://www.seminargo.at/mice-business-news/">FAQ</a></li>
  </ul>
</div>
  </div>
  </div>
 )}
  </div>
  <hr />
  <h1>Seminarhotel finden & buchen</h1>
  <div css={searchStyles}>
  <div className="searchText">
    <h3>Finden Sie Ihr perfektes Seminarhotel</h3>
    <p>Jetzt aus 24.865 Seminar-Locations wählen</p>
  </div>
    <div className="inputFields">
      <div id="singleInput">
      <label htmlFor="place">Location</label>
        <input
          id="place"
          type="text"
          autoComplete="on"
          list="suggestions"
          placeholder="Bundesland"
          value={place}
          onChange={e => {setPlace(e.target.value)}}
              
        />
        <datalist id="suggestions">
        {suggestions.map((suggestion) => (
          <option key={suggestion.id} value={suggestion.name} />
        ))}
      </datalist>
      </div>
      <div id="singleInput">
      <label htmlFor="event-type">Event</label>
        <input
          id="event-type"
          type="text"
          placeholder="Veranstaltungsart"
          value={eventType}
          onChange={e => setEventType(e.target.value)}
        />
      </div>
      <div id="searchButton">
        <button aria-label="search-button"  type="button" onClick={handleSearch}>
          Suchen
        </button>
      </div> 
    </div>
  </div>
</div>

<div css={emptySpace} className="emptyDiv">


<div css={boosterHotelsStyles} className="boosterHotelsContainer" id= "boosterHotels">
<div className="clusterTitle">
<h2>seminargo empfiehlt</h2>
<p>Zufriedene Kunden & zufriedene Hotels - seminargo.com führt zusammen, was zusammengehört!</p>
</div>
<div className="boosterCarousel">
<BoosterCarousel windowWidth={windowWidth}/>
</div>
</div>
</div>

<div css={clusterStyles} className="clustersContainer" id= "clusters">
<div className="clusterTitle">
<h2>Themen</h2>
<p>Sie haben bestimmte Vorstellungen für Ihre Veranstaltung bzw. Ihr Event? Schwebt Ihnen beispielsweise ein mittelalterliches Thema mit einer Burg als Seminar- bzw. Eventlocation vor? Ist es Ihnen wichtig, ein möglichst naturverbundenes Event in den Bergen abzuhalten? Viele Buchende interessieren sich auch für Locations an Gewässern mit verschiedenen Wassersportmöglichkeiten, einen Tagesabschluss bei einer vergnüglichen Weinverkostung, einen stimmungsvollen Ausklang der Veranstaltung im Casino, usw. usf.</p> 
<p>Sie suchen Meetingräume in <a href="https://www.seminargo.at/meetingraum-niederoesterreich/">Niederösterreich</a> oder in anderen österreichischen Bundesländer?</p>
<p>Was auch immer Ihre Wünsche oder Vorstellungen sind: wir haben die passenden Locations und jede Menge Tipps und Vorschläge für Sie parat! Die jahrelange Erfahrung macht es unseren Mitarbeitern ganz einfach möglich, Ihnen zu all Ihren Anfragen wertvolle Infos und Hilfe bei der Organisation bereitzustellen.</p>
</div>
<div className="clusters">
<Carousel windowWidth={windowWidth}/>
</div>
</div>

<div css={boosterAdStyles} className="salesBoosterAdContainer" id= "salesBooster">
    <div className="videoBoosterStyles">
    <div className="vector1">
    <div className="vector2">
          <VideoPlayer videoId={"FgN2uO9yo3k"} windowWidth={windowWidth}/>
      </div>
    </div>
    </div>
  <div className="boosterText">
    <h5>ENTDECKE</h5>
    <h2>seminargo.com Buchungstool</h2>
    <p>Von der einfachen und kostenfreien Tagungshotelvermittlung bis zur Abwicklung des gesamten Beschaffungsprozesses mit seminargo Premium inklusive Verrechnung und Teilnehmerverwaltung für Power-User ist alles für Sie dabei. Konfigurieren Sie selbstständig Ihre Anfrage in unserem innovativen Hotelbuchungssystem.</p>
    <ul>
      <li>Anfrage anlegen</li>
      <li>Hotels anfragen</li>
      <li>Preise vergleichen</li>
      <li>Hotel buchen</li>
    </ul>
    <a href ="https://www.seminargo.com/login/"><button aria-label="seminargo-registration-button">Jetzt registrieren</button></a>
  </div>
</div>

<div css={clusterStyles} className="newTextsContainer" id= "newTexts">
  <div className="clusterTitle">
    <h2>Neu bei seminargo</h2>
    {/* <p>Aktuelle Themen rund um die Tagung. Die seminargo KI hat es herausgefunden und präsentiert hier diese Themen im Überblick:</p> */}
  <p>Gerade beim Thema Seminare, Events, Veranstaltungen, .. geht es darum, immer am Puls der Zeit zu sein. Was sind die neuesten Entwicklungen in diesem Bereich, welche Trends sind im Kommen, wo kann die modernste Technik verwendet werden, worauf achten Teilnehmer derzeit, was ist Hotelgästen wichtig, uvm.</p>
  <p>Wir als seminargo beschäftigen uns mit diesen Themen 24/7 - und wir halten unsere Kunden natürlich auch gerne am Laufenden und teilen unser Wissen mit Freude. Sie können sich sicher sein, mit uns immer am neuesten Stand der Dinge zu sein, denn wir blicken immer in die Zukunft und nach vorne.</p>
  </div>
  <div>
<TextSlideshow apiUrl={'https://www.seminargo.at/wp-json/wp/v2/posts'} windowWidth={windowWidth}/>

</div>
</div>

<div css={emptySpace2} className="emptyDiv2"></div>

<div css={videoStyles} className="videosContainer" id= "videos">
  <div className="videoTitle">
    <h2>Wie funktioniert seminargo?</h2>
    <p>Haben Sie Fragen zur Buchung? Der seminargo.com Buchungsprozess ist an die Bedürfnisse der buchenden Kunden, aber auch an die Bedürfnisse der Hotels angepasst. Durch die Menge an jederzeit offener Buchungsprozesse sind wir in der Lage so manche Anfrage schon vorab beantworten zu können.</p>
  </div>
<VideoSlideshow />
     
    </div>


  <footer css={footerStyles} id= "footer">
      <div className= "footerTitleAndMap">
      <div className="footerTitle">
      <h5>KONTAKT</h5>
      <h2>Live Webinar</h2>
      <h2 id="secondh2">buchen</h2>
      {/* <p id="footTitleText">Wir nehmen uns Zeit für Sie! Gerne zeigen wir Ihnen, wie auch Sie das seminargo Buchungsportal optimal nutzen.</p> */}
      <p id="footTitleText">Buchen Sie hier einen für Sie passenden Termin mit einem unserer Mitarbeiter, der Sie persönlich mit unserem Buchungssystem vertraut macht.</p>
      <button aria-label="enroll-button" onClick={handleContactClick}>Anmelden</button>
      {showModal && (
        <div className="modal">
          <div className="modal-header">
            <button aria-label="close-button" className="close-btn" onClick={handleCloseModal}>
              &times;
            </button>
          </div>
          <div className="modal-content">
          {windowWidth > 950 ? (
            <iframe
              src="https://outlook.office365.com/owa/calendar/DieseminargocomMeetingPlannerbewerbensich@seminargo.com/bookings/"
              title="Booking Schedule"
              width="800px"
              height="400px"
            />
          ) : windowWidth > 750 ?(
            <iframe
              src="https://outlook.office365.com/owa/calendar/DieseminargocomMeetingPlannerbewerbensich@seminargo.com/bookings/"
              title="Booking Schedule"
              width="600px"
              height="400px"
            />
          ) : (
            <iframe
              src="https://outlook.office365.com/owa/calendar/DieseminargocomMeetingPlannerbewerbensich@seminargo.com/bookings/"
              title="Booking Schedule"
              width="100%"
              height="400px"
            />
          )
            }
          </div>
        </div>
      )}
      </div>
      <div className="footerMap">
      {windowWidth > 1000 ? (
      <iframe title="seminargo-location" loading="async" class="hotel-location" width="500px" height="350px" src="https://maps.google.com/maps?q=seminargo GmbH&amp;t=&amp;z=13&amp;ie=UTF8&amp;iwloc=&amp;output=embed" frameborder="0" scrolling="no" marginheight="0" marginwidth="0"></iframe>
      ) : windowWidth > 750 ? (
        <iframe title="seminargo-location" loading="async" class="hotel-location" width="400px" height="300px" src="https://maps.google.com/maps?q=seminargo GmbH&amp;t=&amp;z=13&amp;ie=UTF8&amp;iwloc=&amp;output=embed" frameborder="0" scrolling="no" marginheight="0" marginwidth="0"></iframe>
      ) : windowWidth > 500 ? (
        <iframe title="seminargo-location" loading="async" class="hotel-location" width="300px" height="300px" src="https://maps.google.com/maps?q=seminargo GmbH&amp;t=&amp;z=13&amp;ie=UTF8&amp;iwloc=&amp;output=embed" frameborder="0" scrolling="no" marginheight="0" marginwidth="0"></iframe>
      ) : (
        <iframe title="seminargo-location" loading="async" class="hotel-location" width="120%" height="300px" src="https://maps.google.com/maps?q=seminargo GmbH&amp;t=&amp;z=13&amp;ie=UTF8&amp;iwloc=&amp;output=embed" frameborder="0" scrolling="no" marginheight="0" marginwidth="0"></iframe>
        
       ) }
      </div>
      </div>
      <div className="contactData">
        <div className="location">
        <div className="iconStyle">
        <DynamicIcon icon={"locationDot"} />
        </div>
        <div className = "locationData">
        <h4>Adresse:</h4>
        <p>Liebhartsgasse 16</p>
        <p>1160 Wien</p>
        </div>
        </div>
        <div className="phone">
        <div className="iconStyle">
        <DynamicIcon icon={"phone"} />
        </div>
        <div className = "phoneData">
        <h4>Telefon:</h4>
        <p>+43 1 908 58</p>
        </div>
        </div>
        <div className="email">
        <div className="iconStyle">
        <DynamicIcon icon={"email"} />
        </div>
        <div className = "emailData">
        <h4>E-Mail:</h4>
        <a href="mailto:office@seminargo.com"><p>office@seminargo.com</p></a>
        </div>
        </div>
      </div>
      <div className= "rectangle">
      <div className="socialFooter">
      <a aria-label="Facebook" href="https://www.facebook.com/profile.php?id=100089909419195"><DynamicIcon icon={"facebook"} /></a>
      <a aria-label="Instagram" href="https://www.instagram.com/seminargocom/"><DynamicIcon icon={"instagram"} /></a>
      <a aria-label="LinkedIn" href="https://www.linkedin.com/company/seminargo-gmbh"><DynamicIcon icon={"linkedin"} /></a>
      <a aria-label="Newsletter" href="https://www.seminargo.com/news"><DynamicIcon icon={"newsletter"} /></a>
      </div>
      <div className="linksFooter">
        <a href="https://www.seminargo.com/web/guest/impressum">Impressum</a>
        <a href="https://www.seminargo.com/web/guest/nutzungsbedingungen">Nutzungsbedingungen</a>
      </div>
      </div>
  </footer>
</div>
 
  );
}

export default App;
